/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorScorecardAttributeRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.scorecard.attribute',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorScorecardAttributeRoute);
